import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import React, { useEffect, useState } from "react";
import OrDivider from "./or-devider";
import EmailInput from "./email-input";
import LoadingIcon from "@/app/assets/icons/loading";
import GoogleSignUp from "./google-signup";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ConsentDisclaimer from "@/app/components/shared/consent-disclaimer";
import { emailValidation } from "@/app/model/login";

interface DetermineEmailAuthProps {
    setEmail: React.Dispatch<React.SetStateAction<string>>;
    setName: React.Dispatch<React.SetStateAction<string>>;
    email: string;
    name: string;
    handleEmailVerify: () => void;
    handleGoogleSignUp: () => void;
    emailError: string | null;
    nameError: string | null;
    setEmailError: (type: string) => void;
    setNameError: (type: string) => void;
    buttonLoader: boolean;
    urlRefCode: string;
}

const DetermineEmailAuth: React.FC<DetermineEmailAuthProps> = ({
    email,
    setEmail,
    name,
    setName,
    handleEmailVerify,
    handleGoogleSignUp,
    nameError,
    emailError,
    setNameError,
    setEmailError,
    buttonLoader,
    urlRefCode
}) => {
    const [hasBtnDisabled, setHasBtnDisabled] = useState<boolean>(
        !Boolean(name.trim()) || !Boolean(email.trim()),
    );

    useEffect(() => {
        if (Boolean(name.trim()) || Boolean(email.trim())) {
            setHasBtnDisabled(false);
            window.sessionStorage.setItem("name", name.trim());
            window.sessionStorage.setItem("email", email.trim());
        } else {
            setHasBtnDisabled(true);
            setNameError("");
            setEmailError("");
        }
    }, [name, email]);

    useEffect(() => {
        try {
            // Check validity using zod
            // nameValidation.parse(name);
            emailValidation.parse(email);

            // Enable if email is valid AND name is not empty
            if (name.trim()) {
                setHasBtnDisabled(false);
            } else {
                setHasBtnDisabled(true);
            }

            window.sessionStorage.setItem("name", name.trim());
            window.sessionStorage.setItem("email", email.trim());
        } catch {
            // If either fails validation
            setHasBtnDisabled(true);
        }
    }, [name, email]);

    //    console.log(name.trim(), email.trim());
    //    console.log("hasBtnDisabled ", hasBtnDisabled, !Boolean(name.trim()), !Boolean(email.trim()));

    return (
        <div className="flex w-full flex-col items-start">
            <p className="mb-8 mt-6 text-4xl font-semibold md:mb-4 md:mt-0">Verify your email</p>

            {process.env.APP_GOOGLE_AUTH_SIGNUP_ENABLED === "true" && (
                <GoogleOAuthProvider
                    clientId={String(process.env.APP_GOOGLE_AUTH_CLIENT_ID)}
                    /* redireLocation={"http://localhost/login"} */
                >
                    <GoogleSignUp
                        handleGoogleSignUp={
                            handleGoogleSignUp
                        } /* type="signup" cookieEnabled={true} */
                        urlRefCode={urlRefCode}
                    />
                </GoogleOAuthProvider>
            )}

            <OrDivider />

            <EmailInput
                email={email}
                setEmail={setEmail}
                name={name}
                setName={setName}
                setNameError={setNameError}
                setEmailError={setEmailError}
                emailError={emailError} // Pass email error to child
                nameError={nameError} // Pass name error to child
                hasBtnDisabled={hasBtnDisabled}
                handleEmailVerify={handleEmailVerify}
            />

            {/* {email && email.length && ( */}
            <RegularButton
                size={ButtonSize.Large}
                variant={ButtonVariant.PrimaryDefault}
                className="mt-4 w-full text-lg transition-opacity duration-300 ease-in-out md:w-full md:relative md:bottom-auto md:mb-0 md:mt-4 min-w-full"
                noIcon={true}
                label={
                    buttonLoader ? (
                        <LoadingIcon className="m-auto h-5 w-5 animate-spin" />
                    ) : (
                        "Get OTP"
                    )
                }
                disabled={buttonLoader || hasBtnDisabled}
                showRightIcon={false}
                onClick={handleEmailVerify}
            />
            {/* )} */}
            <ConsentDisclaimer classnames="mt-8"/>
        </div>
    );
};

export default DetermineEmailAuth;
